import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { stateAbbreviations } from "./stateAbbreviations";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPlaceName(placeName: string): string {
  if (!placeName) return '';

  let processedName = placeName;

  // If the name is in "city state" format, convert to "City, State"
  if (!processedName.includes(',')) {
    const words = processedName.split(' ');
    if (words.length > 1) {
      const statePart = words.pop() || '';
      const cityPart = words.join(' ');
      
      const formattedCity = cityPart.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
      const formattedState = statePart.charAt(0).toUpperCase() + statePart.slice(1);
      
      processedName = `${formattedCity}, ${formattedState}`;
    }
  }

  // Now, we assume a "City, State" format and process it
  const parts = processedName.split(',');
  if (parts.length < 2) return processedName; // Not the expected format

  let namePart = parts[0].trim();
  let statePart = parts.slice(1).join(',').trim();

  // Abbreviate state
  if (stateAbbreviations[statePart]) {
    statePart = stateAbbreviations[statePart];
  }

  // Handle consolidated city-county governments like "Louisville/Jefferson County metro government (balance)"
  if (namePart.includes('/')) {
    const cityCountyParts = namePart.split('/');
    if (
      cityCountyParts.length > 1 &&
      cityCountyParts[1].toLowerCase().includes('county metro government (balance)')
    ) {
      namePart = cityCountyParts[0].trim();
    }
  }

  // Handle "metropolitan government (balance)" → "metro"
  const metroSuffix = /metropolitan government \(balance\)$/i;
  if (metroSuffix.test(namePart)) {
    namePart = namePart.replace(metroSuffix, '').trim() + ' metro';
  } else {
    // Optional general suffix cleanup
    const suffixes = ['city', 'town', 'village', 'cdp', 'municipality', 'borough'];
    const nameWords = namePart.split(' ');
    const lastWord = nameWords[nameWords.length - 1].toLowerCase();
    if (suffixes.includes(lastWord)) {
      namePart = nameWords.slice(0, -1).join(' ');
    }
  }

  return `${namePart}, ${statePart}`;
}